import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect, Fragment } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, Button, ListItem, List, Typography, Grid } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { member as v_member, basic, Values, SNACKBAR_TIME } from '../../../request/values';
import ToastStr from '../../../request/toastStr';
import { COLORS } from '../../../shared/Theme';
import { formatMoney, formatMoneyAmount, formatToTimezone } from '../../../locales/formatModule';
import { DialogConfirm, DialogInput } from '../../../components/Dialog';
import { TitleBackBar } from '../../../shared/header/TitleBar';
import { getSavedLanguage } from '../../../locales';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	toolBar: {
		padding: 0,
	},
	back: {
		float: 'left',
		width: '10%',
	},
	titleWrapper: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		float: 'left',
		textAlign: 'center',
		width: '80%',
		justifyContent: 'center',
		'& img': {
			width: '6.5vw',
			height: '6.5vw',
		},
	},
	titleIcon: {
		width: 30,
		height: 30,
	},
	title: {
		fontSize: '6.5vw',
		fontWeight: 'bold',
		color: `${COLORS.WATER_BLUE}`,
		marginLeft: '2vw',
		// marginBottom: '0.5vh',
		// alignItems: 'center',
		// flexGrow: 1,
		// textAlign: 'center',
	},

	buttonSection: {
		textAlign: 'center',
		marginTop: '2vh',
		marginBottom: '1.5vh',
	},
	button: {
		width: '85%',
		height: '6vh',
		...theme.typography.h3,
		fontFamily: 'NanumB',
		fontWeight: 'bold',

		borderRadius: '24px',
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		// border: 'solid 0.5px #cfd4d9',
		[theme.breakpoints.up('md')]: {
			...theme.typography.h3,
			fontFamily: 'NanumB',
			fontWeight: 'bold',
			maxWidth: '550px',
		},
	},

	table: {
		minWidth: 650,
	},
	tableCol1: {
		maxWidth: 150,
	},
	LoanTable: {
		width: '100%',
		height: '62vh',
		// maxHeight: '62vh',
		overflowY: 'auto',
		'& li': {
			backgroundColor: `${COLORS.LIGHT_GREY}`,
			borderRadius: 12,
			border: `solid 1px ${COLORS.VERY_LIGHT_PINK}`,
			marginBottom: '1.5vh',
			fontSize: '3.5vw',
			fontFamily: 'NanumB',
			fontWeight: 'bold',
			color: `${COLORS.BROWNISH_GREY}`,
		},
	},

	tableText: {
		width: '100%',
		...theme.typography.subtitle2,
		color: `${COLORS.BROWNISH_GREY}`,
		borderColor: `${COLORS.BROWNISH_GREY}`,
		'& th, td': {
			padding: 7,
			...theme.typography.subtitle2,
			color: `${COLORS.BROWNISH_GREY}`,
		},
	},

	loanButton: {
		'& button': {
			borderRadius: '8.5px',
			...theme.typography.subtitle1,
		},
	},

	empty: {
		height: '62vh',
		textAlign: 'center',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& img': {
			width: '35vw',
			height: '35vw',
			marginBottom: '2.5vh',
			maxWidth: '270px',
			maxHeight: '270px',
		},
		'& h1': {
			color: `${COLORS.DOWN}`,
		},
	},

	loan: {
		width: '80vw',
		height: '30vw',
	},
}));

type iLoanList = {
	loanNum: number;
	memberName: string;
	currentStock: number;
	loan: number;
	loanInterest: number;
	loanDate: string;
	payback: string;
};

const LoanList: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('student');
	const isEnglish = getSavedLanguage() === 'en';
	const { member } = props;
	let history = useHistory();
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const [loanList, setLoanList] = useState<iLoanList[]>([]);
	const [input, setInput] = useState<boolean>(false);
	// 0 = close, 1 = 요청 , 2 = 확인
	const [confirm, setConfirm] = useState<number>(0);
	const [item, setItem] = useState<number>(0);

	const handleClose = (key: string) => {
		if (key === 'input') setInput((prevState) => !prevState);
		else if (key === 'confirm') setConfirm((prevState) => 0);
	};

	const handleOpen = (key: string) => {
		if (key === 'input' && !input) {
			setInput((prevState) => !prevState);
		}
	};

	const getLoanList = () => {
		let url = new URL(SERVER + v_member.member + v_member.company_loan_list);
		let params = { companyNum: member.companyNum, classCode: member.classCode };
		url.search = new URLSearchParams(params).toString();

		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => res.data)
			.then((data) => {
				console.log('res data : ', data, data.loanList.length);
				if (data.code === Values.SUCCESS_CODE) {
					setLoanList(data.loanList);
				}
			});
	};

	const postLoan = (e: any, loan: number) => {
		console.log(loan);
		axios({
			method: 'POST',
			data: {
				loan_price: loan,
				company_num: member.companyNum,
				member_name: member.name,
				class_code: member.classCode,
			},
			withCredentials: true,
			url: SERVER + v_member.member + v_member.company_loan,
		})
			.then((res) => res.data)
			.then((data) => {
				console.log('loan submit', data);
				if (data.code === Values.SUCCESS_CODE) {
					if (data.loanList == null) {
						enqueueSnackbar(ToastStr.LOAN_SUCCESS_STR, { variant: 'success', autoHideDuration: SNACKBAR_TIME });
					}
					getLoanList();
				} else if (data.code === Values.OVER_LOAN_CODE) {
					enqueueSnackbar(ToastStr.LOAN_OVER_LOAN_STR, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
				} else if (data.code === Values.CLASS_FINISH_CODE) {
					enqueueSnackbar(ToastStr.LOAN_CLASS_FINISH_STR, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
				} else {
					enqueueSnackbar(ToastStr.LOAN_FAIL_STR, { variant: 'error', autoHideDuration: SNACKBAR_TIME });
				}
			});
		handleClose('input');
	};

	const yesConfirm = () => {
		// confirm !== false && loanPayBack(loanList[confirm as number].loanNum, loanList[confirm as number].loan + loanList[confirm as number].loanInterest)
		if (confirm === 1) {
			loanPayBack(loanList[item].loanNum, loanList[item].loan + loanList[item].loanInterest);
		}
	};

	const loanPayBack = (loanNum: number, loan: number) => {
		setConfirm(0);
		axios({
			method: 'POST',
			data: {
				loan_num: loanNum,
				company_num: member.companyNum,
				payback_price: loan,
				class_code: member.classCode,
			},
			withCredentials: true,
			url: SERVER + v_member.member + v_member.company_loan_payback,
		})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code === Values.SUCCESS_CODE) {
					enqueueSnackbar(ToastStr.LOAN_PAYBACK_SUCCESS_STR, { variant: 'success', autoHideDuration: SNACKBAR_TIME });
					setConfirm(2);
					console.log(2);
				} else if (data.code === Values.CLASS_NO_START_CODE) enqueueSnackbar(ToastStr.LOAN_CLASS_NO_START_STR, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
				else if (data.code === Values.CLASS_FINISH_CODE) enqueueSnackbar(ToastStr.LOAN_CLASS_FINISH_STR, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
				else if (data.code === Values.INSUFFICIENT_CODE) enqueueSnackbar(ToastStr.LOAN_INSUFFICIENT_STR, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
				else if (data.code === Values.FAIL_CODE) enqueueSnackbar(ToastStr.LOAN_PAYBACK_FAIL_STR, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
				else if (data.code === Values.EXCEPTION_CODE)
					enqueueSnackbar(ToastStr.LOAN_PAYBACK_UPDATE_EXCEPTION_STR, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
					});
				else enqueueSnackbar(ToastStr.ERROR, { variant: 'error', autoHideDuration: SNACKBAR_TIME });

				console.log(data);
			})
			.then(() => {
				getLoanList();
			});
		// setConfirm(2)
	};

	useEffect(() => {
		getLoanList();
	}, []);
	return (
		<div className="content">
			<TitleBackBar history={history} title={t('LoanList.title')} titleIcon="price" />

			{loanList.length != 0 ? (
				<List className={classes.LoanTable}>
					{loanList.map((item: any, index: number) => {
						return (
							<LoanItem
								index={index}
								item={item}
								// payback={() => loanPayBack(item.loanNum, item.loan+item.loanInterest)}
								payback={() => {
									setConfirm(1);
									setItem(index);
								}}
								// payback={() => {console.log('payback')}}
							/>
						);
					})}
				</List>
			) : (
				<div className={classes.empty}>
					<div>
						<img src={isEnglish ? '/images/empty_loan_en.webp' : '/images/empty_loan.webp'} />
						<Typography variant="h1">{t('LoanList.empty')}</Typography>
					</div>
				</div>
			)}

			<div className={classes.buttonSection}>
				<Button onClick={() => handleOpen('input')} className={classes.button} style={{ backgroundColor: `${COLORS.PUMPKIN}`, color: `${COLORS.WHITE}` }} data-testid="get-loan-btn">
					{t('LoanList.loanButton')}
				</Button>
			</div>

			<DialogInput
				dialogStyle={classes.loan}
				open={input}
				handleClose={() => handleClose('input')}
				title={t('LoanList.inputTitle')}
				yesConfirm={(e: any, loan: number) => postLoan(e, loan)}
				noConfirm={() => handleClose('input')}
			/>
			<DialogConfirm
				open={confirm === 0 ? false : true}
				handleClose={() => handleClose('confirm')}
				title={t('LoanList.title')}
				context={
					confirm === 1
						? loanList !== null && formatMoneyAmount(loanList[item as number].loan + loanList[item as number].loanInterest) + t('LoanList.repayQuestionSuffix')
						: confirm === 2
							? loanList !== null && formatMoneyAmount(loanList[item as number].loan + loanList[item as number].loanInterest) + t('LoanList.repayDoneSuffix')
							: ''
				}
				yesConfirm={confirm !== 2 ? yesConfirm : handleClose('confirm')}
				noConfirm={() => handleClose('confirm')}
				alarm={confirm === 2 ? true : false}
			/>
		</div>
	);
};

const LoanItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { item, payback, index } = props;
	const { t } = useTranslation('student');
	const formattedTimezone = formatToTimezone(item.loanDate);
	const formattedDate = formattedTimezone ? formattedTimezone[0] : '';
	const formattedTime = formattedTimezone ? formattedTimezone[1] : '';
	const click = () => {
		console.log('click', item.payback);
		if (item.payback !== 'complete') {
			payback();
		}
	};

	return (
		<ListItem>
			<Grid container>
				<Grid xs={6}>
					<TableContainer component={Paper} style={{ boxShadow: 'none', backgroundColor: `${COLORS.LIGHT_GREY}` }}>
						<Table>
							<TableBody>
								<TableRow className={classes.tableText}>
									<TableCell align="left" style={{ borderBottom: 'none', paddingLeft: 0 }} component="th" scope="row">
										{t('LoanList.principal')}
									</TableCell>
									<TableCell align="right" style={{ borderBottom: 'none' }}>
										{formatMoney(item.loan)}
									</TableCell>
								</TableRow>
								<TableRow className={classes.tableText}>
									<TableCell align="left" style={{ borderBottomColor: `${COLORS.BROWNISH_GREY}`, paddingLeft: 0 }} component="th" scope="row">
										{t('LoanList.interest')}
									</TableCell>
									<TableCell align="right" style={{ borderBottomColor: `${COLORS.BROWNISH_GREY}` }}>
										{formatMoney(item.loanInterest)}
									</TableCell>
								</TableRow>
								{/* <Divider/> */}
								<TableRow className={classes.tableText}>
									<TableCell align="left" style={{ borderBottom: 'none', paddingLeft: 0 }} component="th" scope="row">
										{t('LoanList.total')}
									</TableCell>
									<TableCell align="right" style={{ borderBottom: 'none', color: `${COLORS.PUMPKIN}` }}>
										{formatMoney(item.loanInterest + item.loan)}
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
				<Grid xs={6} container direction="column" alignItems="flex-end" style={{ justifyContent: 'space-around' }}>
					<Grid item>
						<Typography variant="body1">{formattedTime}</Typography>
					</Grid>
					<Grid item>
						<div className={classes.loanButton}>
							{item.payback === 'complete' ? (
								<Button disabled style={{ backgroundColor: `${COLORS.LIGHT_BLUE_GREY}`, color: `${COLORS.WHITE}` }} data-testid={`loan-repay-btn-disabled-${index}`}>
									{t('LoanList.repayComplete')}
								</Button>
							) : (
								<Button onClick={() => click()} style={{ backgroundColor: `${COLORS.WATER_BLUE}`, color: `${COLORS.WHITE}` }} data-testid={`loan-repay-btn-${index}`}>
									{t('LoanList.repay')}
								</Button>
							)}
						</div>
					</Grid>
				</Grid>
			</Grid>
		</ListItem>
	);
};

export default LoanList;
